import {
  FETCH_ALL_WAREHOUSES,
  FETCH_PAGINATE_WAREHOUSES,
  FETCH_CURRENT_WAREHOUSE,
  // FETCH_CURRENT_WAREHOUSE_PRODUCTS,
  FETCH_PAGINATE_WAREHOUSE_PRODUCTS,
  FETCH_ALL_WAREHOUSE_TRANSACTIONS,
  FETCH_ALL_WAREHOUSE_TRANSACTIONSV2,
  FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2,
} from './../../mutation-types';

export default {
  [FETCH_ALL_WAREHOUSES](state, warehouses) {
    state.all = warehouses;
  },

  [FETCH_PAGINATE_WAREHOUSES](state, { warehouses, pagination }) {
    state.items = warehouses;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_WAREHOUSE](state, warehouse) {
    state.currentWarehouse = warehouse;
  },

  // [FETCH_CURRENT_WAREHOUSE_PRODUCTS](state, products) {
  //   state.products = products;
  // },

  [FETCH_PAGINATE_WAREHOUSE_PRODUCTS](state, { products, pagination }) {
    state.products.items = products;
    state.products.pagination = pagination;
  },

  [FETCH_ALL_WAREHOUSE_TRANSACTIONS](state, transactions) {
    state.transactions = transactions;
  },

  // TRANSACTIONSV2
  [FETCH_ALL_WAREHOUSE_TRANSACTIONSV2](state, transactionsV2All) {
    state.transactionsV2All = transactionsV2All;
  },
  [FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2](state, { transactions, pagination }) {
    state.transactionsV2.items = transactions;
    state.transactionsV2.pagination = pagination;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/warehouse/mutations.js